import { Row, Col } from "react-bootstrap";
import { useIntl } from "react-intl";
import Config from "../config/Config";
import SectionWrapper from "./SectionWrapper";
import DppProductImage from "./DppProductImage";
import DppProductInfo from "./DppProductInfo";


function DppOverview({ assetAdministrationShell, submodelDescriptors }) {
  const { mainColor } = Config.appearance;
  const intl = useIntl();
  const sectionTitle = intl.formatMessage({ id: "product_overview" });

  return (
    <SectionWrapper 
      title={sectionTitle}
      titleStyle={{'--dpp-main-color': mainColor}}
      contentStyle={{padding: "12px"}}
    >
      <Row lg={'auto'}>
        {/* Product Image */}
        <Col xs={12} sm={12} md={12} lg={4} xl={4} className="d-flex align-items-center justify-content-center" style={{ minHeight: "289px"}}>
          <DppProductImage
            submodelDescriptors={submodelDescriptors}
          />
        </Col>
        {/* Product Info */}
        <Col xs={12} sm={12} md={12} lg={8} xl={8} className="d-flex align-items-center justify-content-left">
          <DppProductInfo
            assetAdministrationShell={assetAdministrationShell}
            submodelDescriptors={submodelDescriptors}
          />
        </Col>
      </Row>
    </SectionWrapper>
  );
}

export default DppOverview;